import { render, staticRenderFns } from "./DetailBooking.vue?vue&type=template&id=333d1cba&scoped=true&"
import script from "./DetailBooking.vue?vue&type=script&lang=js&"
export * from "./DetailBooking.vue?vue&type=script&lang=js&"
import style0 from "./DetailBooking.vue?vue&type=style&index=0&id=333d1cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333d1cba",
  null
  
)

export default component.exports